const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://kcnsongkhoai-api.cgis.asia/",
    media_url: "https://kcnsongkhoai-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "kcnsongkhoai",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
    datastore: 'kcnsongkhoai',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/",
  },
    production: {
      api: "https://kcnsongkhoai-api.cgis.asia/",
      media_url: "https://kcnsongkhoai-api.cgis.asia/",
      domainAdminSide: "https://admin.kcnsongkhoai.cgis.asia",
      domainUserSide: "https://kcnsongkhoai.cgis.asia",
      domainName: "kcnsongkhoai.cgis.asia",
      workSpace: "kcnsongkhoai",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
      datastore: 'kcnsongkhoai',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
      // wmsBaseLink: "https://geo3.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];